// Import dependencies
import React, { useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";

// Import motion library
import { motion } from "framer-motion";

// Import lottie components
import Gear from "../Lotties/Gear";

// Import data content
import { content } from "../assets/data/Content";

// Import components
import Helmet from "../components/Helmet/Helmet";
import ServiceCard from "../components/ServiceCard/ServiceCard";

// Framer-motion configuration
const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.5,
      duration: 0.5,
    },
  },
};

const Services = () => {
  // Data content
  const { services } = content;

  // Ref to UL container of the ServiceCard
  const ref = useRef(null);

  // Ref to animation to return home page
  const gearReturn = useRef(null);

  // Use effect to detected when making scroll into the page
  useEffect(() => {
    let element = ref.current;

    // Rotate animation
    const rotate = () => {
      element.style.transform = `translateX(${-window.scrollY}px)`;

      return (gearReturn.current.style.transform =
        "rotate(" + -window.scrollY + "deg)");
    };

    window.addEventListener("scroll", rotate);

    return () => {
      window.removeEventListener("scroll", rotate);
    };
  }, []);

  return (
    <>
      <Helmet title="Servicios">
        <section>
          <div className="fixed z-[1] p-8 bg-bg_light_primary m-0">
            <h2 className="title" data-aos="fade-right">
              {services.title}
            </h2>

            <h4 className="subtitle" data-aos="fade-left">
              {services.subtitle}
            </h4>
          </div>

          <div className="bg-bg_light_primary h-[280vh] md:h-[200vh] relative flex items-center">
            <motion.ul
              className="fixed top-[12rem] left-[30%] h-[40vh] flex"
              ref={ref}
              variants={container}
              initial="hidden"
              animate="show"
            >
              {/* Generate service card */}
              {services.serviceContent.map((service) => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </motion.ul>

            {/* Link to return home page */}
            <NavLink
              to={"/home"}
              className="rotate__services block fixed right-[-1rem] bottom-[1rem] h-[200px] z-[1]"
              ref={gearReturn}
            >
              <Gear />
            </NavLink>
          </div>
        </section>
      </Helmet>
    </>
  );
};

export default Services;
